import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { HoursAndDirectionsForm } from 'components/facility/HoursAndDirectionsForm';
import { Modal, ModalBody } from 'components/core/Modal';


export function HoursAndDirectionsModal({
	className, showing = false, facilityId, onClose = noop, onSubmit
}) {
	return (
		<Modal
			className={classnames(className, 'hours-and-directions-modal')}
			showing={showing}
			closeable
			onClose={onClose}
		>
			<ModalBody>
				<HoursAndDirectionsForm
					facilityId={facilityId}
					onClose={onClose}
					onSubmit={onSubmit}
				/>
			</ModalBody>
		</Modal>
	);
}

HoursAndDirectionsModal.propTypes = {
	className: PropTypes.string,
	showing: PropTypes.bool,
	facilityId: PropTypes.number,
	onClose: PropTypes.func,
	onSubmit: PropTypes.func.isRequired
};

export default HoursAndDirectionsModal;
